<script setup>
import { useHead } from "@vueuse/head";

const eventJsonLd = {
  "@context": "https://schema.org",
  "@type": "Event",
  name: "Sewcase auf der DoKomi 2025",
  startDate: "2025-06-07T10:00",
  endDate: "2025-06-08T18:00",
  eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
  location: {
    "@type": "Place",
    name: "Messe Düsseldorf",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Stockumer Kirchstraße 61",
      addressLocality: "Düsseldorf",
      postalCode: "40474",
      addressCountry: "DE",
    },
  },
  image: "https://sewcase.de/img/dokomi-booth.jpg",
  description:
    "Treffe Sewcase auf der DoKomi! Entdecke neue Cosplay-Projekte, Workshops und spannende Produkte.",
  organizer: {
    "@type": "Organization",
    name: "Sewcase",
    url: "https://sewcase.de",
  },
};

useHead({
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify(eventJsonLd),
    },
  ],
});
</script>
